import React from 'react';

import { TableCell } from '@gogame/components';

import { ActivityTypesIndicator } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components';
import Tree from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Tree';

const TreePreview = () => (
  <Tree
    renderIndicatorTotal={({ activityType }) => (
      <ActivityTypesIndicator type={activityType} />
    )}
    renderIndicatorCell={({ activityType }) => (
      <TableCell padding={'none'}>
        <ActivityTypesIndicator type={activityType} />
      </TableCell>
    )}
  />
);

export default TreePreview;
